var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.$root.logged_in,
          expression: "!$root.logged_in"
        }
      ],
      staticClass: "chi-form chi-login",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("chi-welcome"),
          _c(
            "div",
            { staticClass: "chi-form-section right" },
            [
              _c("chi-announcements"),
              _c("div", { staticClass: "chi-form-section login-form" }, [
                _c("h2", { staticClass: "with-cropped-hr centered" }, [
                  _vm._v("Log Into Your Account")
                ]),
                _c("div", {
                  staticClass: "chi-login-errors",
                  attrs: {
                    id: "chi-login-notifications",
                    "data-conn-message":
                      "Failed to connect to server. Please try again later.",
                    "data-fail-message": "Invalid username and/or password!",
                    "data-pass-message": "Password cannot be blank!",
                    "data-user-message": "Username cannot be blank!"
                  }
                }),
                _c(
                  "div",
                  {
                    staticClass: "chi-form-group input-group",
                    class: { "has-chi-login-error": _vm.error.user }
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "chi-login-label",
                        attrs: { for: "user" }
                      },
                      [_vm._v("Username")]
                    ),
                    _vm.user_visible
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.lazy",
                              value: _vm.model.username,
                              expression: "model.username",
                              modifiers: { lazy: true }
                            }
                          ],
                          ref: "user",
                          staticClass: "k-textbox full-width",
                          class: { "k-space-right": _vm.error.user },
                          attrs: {
                            id: "user",
                            tabindex: "1",
                            type: "text",
                            name: _vm.random
                          },
                          domProps: { value: _vm.model.username },
                          on: {
                            keypress: _vm.onkeypress,
                            change: function($event) {
                              return _vm.$set(
                                _vm.model,
                                "username",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.error.user
                      ? _c("i", {
                          staticClass:
                            "fal fa-fw fa-exclamation-circle chi-login-error-icon",
                          attrs: {
                            title: _vm.error.user
                              ? "Invalid or blank username"
                              : ""
                          }
                        })
                      : _vm._e()
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "chi-form-group input-group",
                    class: { "has-chi-login-error": _vm.error.pass }
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "chi-login-label",
                        attrs: { for: "pass" }
                      },
                      [_vm._v("Password")]
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.lazy",
                          value: _vm.model.password,
                          expression: "model.password",
                          modifiers: { lazy: true }
                        }
                      ],
                      ref: "pass",
                      staticClass: "k-textbox full-width",
                      class: { "k-space-right": _vm.error.pass },
                      attrs: {
                        id: "pass",
                        name: "pass",
                        tabindex: "2",
                        type: "password"
                      },
                      domProps: { value: _vm.model.password },
                      on: {
                        keypress: _vm.onkeypress,
                        change: function($event) {
                          return _vm.$set(
                            _vm.model,
                            "password",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm.error.pass
                      ? _c("i", {
                          staticClass:
                            "fal fa-fw fa-exclamation-circle chi-login-error-icon",
                          attrs: {
                            title: _vm.error.pass
                              ? "Invalid or blank password"
                              : ""
                          }
                        })
                      : _vm._e()
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "chi-button-group chi-form-group" },
                  [
                    _c(
                      "kendo-button",
                      {
                        staticClass: "chi-button-primary",
                        attrs: {
                          id: "login",
                          "sprite-css-class": "chi-icon-log-in",
                          tabindex: "3",
                          type: "submit"
                        }
                      },
                      [_vm._v("Log In")]
                    ),
                    _c(
                      "kendo-button",
                      {
                        attrs: {
                          id: "clear",
                          "sprite-css-class": "chi-icon-backspace",
                          tabindex: "4",
                          type: "reset"
                        },
                        on: {
                          click: function($event) {
                            return _vm.clear()
                          }
                        }
                      },
                      [_vm._v("Clear")]
                    )
                  ],
                  1
                ),
                _c("a", { staticClass: "tos", attrs: { name: "tos" } }, [
                  _vm._v("Terms of Service")
                ]),
                !!_vm.launch_accessibility
                  ? _c(
                      "div",
                      { staticClass: "chi-form-group chi-accessibility" },
                      [
                        _vm._v(" For accessibility settings, "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.launch_accessibility)
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }